export default class Area {
  static fromJSON (json) {
    if (!json) {
      return new Area({ feet: 0, metres: 0 })
    }
    return new Area({
      feet: json.feet || 0,
      metres: json.metres || 0
    })
  }

  constructor ({ feet, metres }) {
    this.feet = parseFloat(feet).toFixed(2)
    this.metres = metres
  }
}
